import { useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import SearchBar from 'src/componentes/filtro/search-drawer/SearchBar';
import InformacoesBasicasSecao from './sections/InformacoesBasicas';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';

const PontoControleSearch = ({
  model,
  resources,
  intl,
  configuracao,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <>
      <SearchBar
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <InformacoesBasicasSecao
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      <CustomFieldsSection
        model={model}
        intl={intl}
        searchQuery={searchQuery}
      />
    </>
  );
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(PontoControleSearch));